import { createSlice } from '@reduxjs/toolkit';
import { initialPermissionsState } from './permissions.initial';
import { fetchRetentionPermissions } from './thunks';

export const permissionsSlice = createSlice({
    name: 'permissions',
    initialState: initialPermissionsState,
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(fetchRetentionPermissions.pending, (state) => {
            state.status = 'loading';
            state.error = null;
        });
        builder.addCase(fetchRetentionPermissions.fulfilled, (state, action) => {
            state.status = 'success';
            state.flags = action.payload;
        });
        builder.addCase(fetchRetentionPermissions.rejected, (state, action) => {
            state.status = 'error';
            state.error = action.error.message ?? 'Error cargando permisos';
        });
    },
});

export default permissionsSlice.reducer;
